import {Directive, ElementRef, HostListener, forwardRef, Input, AfterViewInit} from '@angular/core';
import {UntypedFormControl, NG_VALIDATORS} from "@angular/forms";
import {isString} from "util";
import {filter} from "rxjs/operators";
import {DecimalPipe} from "@angular/common";

@Directive({
  selector: '[rci-number-format][ngModel]',
  providers: [
    {provide: NG_VALIDATORS, useExisting: forwardRef(() => RciNumberFormatDirective), multi: true}
  ]
})
export class RciNumberFormatDirective implements AfterViewInit{

  constructor(private el: ElementRef, private decimalPipe: DecimalPipe) {
  }

  ngAfterViewInit() {
    this.el.nativeElement.value = this.convertNumber(this.parseNumber(this.el.nativeElement.value));
  }

  validate(control: UntypedFormControl) {
    if (control.value == undefined) {
      return null;
    }
    let number = control.value;
    if (typeof number === 'string' || number instanceof String) {
      number = number.replace('.', '').replace(',', '.');
      number = parseFloat(number);
    }
    if (isNaN(number)) {
      return {
        decimal: true
      };
    }
    return null;
  }

  @HostListener('keydown', ['$event']) onKeyDown(event) {
    let keyboardEvent = <KeyboardEvent>event;

    if (
      // Allow: Ctrl+A
      (keyboardEvent.code === 'KeyA' && (keyboardEvent.ctrlKey || keyboardEvent.metaKey)) ||
      // Allow: Ctrl+C
      (keyboardEvent.code === 'KeyC' && (keyboardEvent.ctrlKey || keyboardEvent.metaKey)) ||
      // Allow: Ctrl+V
      (keyboardEvent.code === 'KeyV' && (keyboardEvent.ctrlKey || keyboardEvent.metaKey)) ||
      // Allow: Ctrl+X
      (keyboardEvent.code === 'KeyX' && (keyboardEvent.ctrlKey || keyboardEvent.metaKey)) ||
      (keyboardEvent.code === 'Tab') ||
      (keyboardEvent.code === 'Delete') ||
      (keyboardEvent.code === 'Backspace') ||
      // Allow: home, end, left, right
      (keyboardEvent.code === 'ArrowLeft' || keyboardEvent.code === 'ArrowRight' || keyboardEvent.code === 'Home' || keyboardEvent.code === 'End') ||
      (keyboardEvent.code === 'Digit0') ||
      (keyboardEvent.code === 'Digit1') ||
      (keyboardEvent.code === 'Digit2') ||
      (keyboardEvent.code === 'Digit3') ||
      (keyboardEvent.code === 'Digit4') ||
      (keyboardEvent.code === 'Digit5') ||
      (keyboardEvent.code === 'Digit6') ||
      (keyboardEvent.code === 'Digit7') ||
      (keyboardEvent.code === 'Digit8') ||
      (keyboardEvent.code === 'Digit9') ||
      (keyboardEvent.code === 'Numpad0') ||
      (keyboardEvent.code === 'Numpad1') ||
      (keyboardEvent.code === 'Numpad2') ||
      (keyboardEvent.code === 'Numpad3') ||
      (keyboardEvent.code === 'Numpad4') ||
      (keyboardEvent.code === 'Numpad5') ||
      (keyboardEvent.code === 'Numpad6') ||
      (keyboardEvent.code === 'Numpad7') ||
      (keyboardEvent.code === 'Numpad8') ||
      (keyboardEvent.code === 'Numpad9')) {
      // let it happen, don't do anything
      return;
    }

      // Allow: comma
      if (keyboardEvent.code === 'Comma' || keyboardEvent.code === 'NumpadDecimal') {
        var count = (this.el.nativeElement.value.match(/,/g) || []).length;
        if (count != null && count > 0) {
          event.preventDefault();
        } else {
          return;
        }
      }

      // Allow: dot
      if (keyboardEvent.code === 'Period') {
        var count = (this.el.nativeElement.value.match(/\./g) || []).length;
        if (count != null && count > 0) {
          event.preventDefault();
        } else {
          return;
        }
      }

      event.preventDefault();
  }

  parseNumber(number) {
    var result = number;
    if (isString(number)) {
      result = number.replace(/[^\d\-,]/g, '').replace(',', '.');
      result = parseFloat(result);
    }
    return result;
  }

  convertNumber(floatNumber) {
    return this.decimalPipe.transform(floatNumber, '1.2-2');
  }

  @HostListener('blur', ['$event']) onBlur(event) {
    this.el.nativeElement.value = this.convertNumber(this.parseNumber(event.target.value));
  }

  @HostListener('change') ngOnChanges() {
    this.el.nativeElement.value = this.convertNumber(this.parseNumber(this.el.nativeElement.value));
  }
}

